import firebase from '@/firebase'
const db = firebase.db
const functions = firebase.functions

const state = {
  autoModelRequests: [],
  unsubscribeAutoModelRequests: null
}

const getters = {
  autoModelRequests: state => {
    return state.autoModelRequests
  }
}

const actions = {
  createAutoModelRequest (context, payload) {
    return new Promise(function (resolve, reject) {
      var docRef = db.collection('auto_model_requests').doc()
      var docId = docRef.id
      docRef.set({
        name: payload.name,
        storagePath: null,
        originalFileName: null,
        dateCreated: Date.now(),
        dateUploaded: null,
        lastActivityDate: Date.now(),
        uploadedBy: payload.uploadedBy,
        uploaded_by_id: payload.uploadedById,
        status: 'pending',
        monthly: payload.monthly || false
      }).then(function () {
        resolve({ id: docId })
      }).catch(function (error) {
        console.error('Error creating auto model request: ', error)
        reject(error)
      })
    })
  },
  uploadAutoModelFile (context, payload) {
    var docRef = db.collection('auto_model_requests').doc(payload.docId)
    var storagePath = '/autoModelData/staging/' + payload.userId + '/' + payload.docId + '/data.xlsx'
    return docRef.update({
      storagePath: storagePath,
      originalFileName: payload.originalFileName,
      dateUploaded: Date.now(),
      lastActivityDate: Date.now(),
      status: 'uploaded',
      validation: null,
      mediaChannels: null,
      monthly: payload.monthly || false
    }).then(function () {
      return { storagePath: storagePath }
    })
  },
  loadAutoModelRequests (context, payload) {
    var userId = (payload && payload.userId) || payload
    var loadAll = (payload && payload.loadAll) || false
    if (!userId && !loadAll) return
    // Cleanup existing listener before creating a new one
    if (context.state.unsubscribeAutoModelRequests) {
      context.state.unsubscribeAutoModelRequests()
    }
    var query = db.collection('auto_model_requests')
    if (!loadAll) {
      query = query.where('uploaded_by_id', '==', userId)
    }
    var unsubscribe = query.onSnapshot(snapshot => {
      var requests = []
      snapshot.forEach(doc => {
        var data = doc.data()
        requests.push({
          ...data,
          id: doc.id
        })
      })
      context.commit('setAutoModelRequests', requests)
    })
    context.commit('setUnsubscribeAutoModelRequests', unsubscribe)
  },
  deleteAutoModelRequest (context, payload) {
    var deleteAutoModelv2 = functions.httpsCallable('autoModels-deleteAutoModelv2')
    return deleteAutoModelv2({ docId: payload.docId })
  },
  queueAutoModelGeneration (context, payload) {
    var docRef = db.collection('auto_model_requests').doc(payload.docId)
    return docRef.update({
      name: payload.name,
      user_priors: payload.user_priors,
      pretty_names_media: payload.pretty_names_media || null,
      status: 'queued',
      lastActivityDate: Date.now()
    })
  },
  checkClientNameExists (context, modelName) {
    var checkName = functions.httpsCallable('autoModels-checkClientNameExists')
    return checkName({ modelName: modelName }).then(function (result) {
      return result.data.exists
    })
  },
  cleanupListeners (context) {
    if (context.state.unsubscribeAutoModelRequests) {
      context.state.unsubscribeAutoModelRequests()
      context.commit('setUnsubscribeAutoModelRequests', null)
    }
  }
}

const mutations = {
  setAutoModelRequests (state, requests) {
    state.autoModelRequests = requests
  },
  setUnsubscribeAutoModelRequests (state, unsubscribe) {
    state.unsubscribeAutoModelRequests = unsubscribe
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
